// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"348":"97121251","1150":"906782d4","2082":"e232be87","2246":"6db128db","2309":"6b478cd1","4784":"1f93e37a","5722":"494a7c48","6743":"37edc9ff"}[chunkId] + ".chunk.css";
};